import type { SVGProps } from 'react';
const securityLockFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.5 1.563a4.687 4.687 0 0 1 4.688 4.687v3.906h.78c1.249 0 2.27.976 2.34 2.206l.005.138v8.594a2.344 2.344 0 0 1-2.344 2.343H7.03a2.344 2.344 0 0 1-2.343-2.343V12.5a2.344 2.344 0 0 1 2.343-2.344h.782V6.25A4.688 4.688 0 0 1 12.5 1.562zm0 12.5a1.563 1.563 0 0 0-.757 2.93.783.783 0 0 0-.024.195v1.562a.781.781 0 1 0 1.562 0v-1.563a.75.75 0 0 0-.025-.194 1.562 1.562 0 0 0-.756-2.93zm0-10.938A3.125 3.125 0 0 0 9.375 6.25v3.906h6.25V6.25c0-1.726-1.4-3.125-3.125-3.125z"
      fill={props.color ?? '#47AACF'}
      fillRule="evenodd"
    />
  </svg>
);
export default securityLockFilled;
